import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import chartsOnline from './modules/chartsOnline'
import filters from './modules/filters'
import filtersOn from './modules/filtersOn'
import grid from './modules/grid'
import gridOnline from './modules/gridOnline'
import modal_rdp from './modules/modal_rdp'
import modal_photo from './modules/modal_photo'
import menu from './modules/menu'
import { state, mutations, actions } from './mutations'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'


export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    user,
    auth,
    grid,
    gridOnline,
    filters,
    filtersOn,
    chartsOnline,
    modal_rdp,
    modal_photo,
    menu
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js